import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { supabase } from '@/lib/axios'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/tokens',
    name: 'tokens',
    component: () => import('../views/TokensView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue')
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/ResetPasswordView.vue')
  },
  {
    path: '/update-password',
    name: 'update-password',
    component: () => import('../views/UpdatePasswordView.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Gezinme koruması
router.beforeEach(async (to, from, next) => {
  // Oturum gerektiren sayfalar için kontrol
  const { data: { session } } = await supabase.auth.getSession();
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!session) {
      // Oturum yoksa giriş sayfasına yönlendir
      next({ name: 'login' });
    } else {
      next();
    }
  } else if (to.name === 'home' || to.path === '/') {
    // Kullanıcı giriş yapmışsa ve ana sayfaya gidiyorsa doğrudan token sayfasına yönlendir
    if (session) {
      next({ name: 'tokens' });
    } else {
      next();
    }
  } else if ((to.name === 'login' || to.name === 'register' || to.name === 'reset-password') && session) {
    // Giriş yapmış kullanıcı auth sayfalarına gitmeye çalışırsa token sayfasına yönlendir
    next({ name: 'tokens' });
  } else {
    next();
  }
});

export default router
